import { INTERAX_COLORS } from '../../../constants/colors'
import { COMPONENT_DIMENSIONS } from '../../../constants/layout'

export const ORG_TABLE_ROW_ACTION_ICON_SIZE_PX = COMPONENT_DIMENSIONS.ICON_SM

export const orgTableHeadCellSx = {
  color: INTERAX_COLORS.white70,
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0.5,
  textTransform: 'uppercase' as const,
  borderBottom: `1px solid ${INTERAX_COLORS.white10}`,
  py: 1.5
}

export const orgTableBodyCellSx = {
  color: INTERAX_COLORS.white,
  fontSize: 14,
  borderBottom: `1px solid ${INTERAX_COLORS.white10}`,
  py: 1.5
}

export const orgTableRowSx = {
  transition: 'background-color 120ms',
  '&:hover': { backgroundColor: INTERAX_COLORS.white04 },
  '&:last-of-type td': { borderBottom: 'none' }
}

export const orgTableRowActionSx = {
  color: INTERAX_COLORS.white70,
  '&:hover': { color: INTERAX_COLORS.sun, backgroundColor: INTERAX_COLORS.white04 }
}

export const orgTablePaginationSx = {
  color: INTERAX_COLORS.white70,
  borderTop: `1px solid ${INTERAX_COLORS.white10}`,
  '.MuiTablePagination-toolbar': { color: INTERAX_COLORS.white70 },
  '.MuiTablePagination-selectIcon': { color: INTERAX_COLORS.white70 },
  '.MuiIconButton-root': { color: INTERAX_COLORS.white70 },
  '.MuiIconButton-root.Mui-disabled': { color: INTERAX_COLORS.white30 },
  '.MuiTablePagination-select': { color: INTERAX_COLORS.white },
  '.MuiTablePagination-actions button:hover': {
    backgroundColor: INTERAX_COLORS.white10
  }
}

export const orgTableCardSx = {
  backgroundColor: INTERAX_COLORS.heritageBlue40,
  border: `1px solid ${INTERAX_COLORS.white10}`,
  borderRadius: 3,
  overflow: 'hidden'
} as const
